var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { TreatmentLabel } from '@/models/TreatmentLabel';
import { Treatment as TreatmentModel } from '@/models/Treatment';
import { Component, Vue, Model, Prop } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import ErrorHandler from '@/support/ErrorHandler';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { ucstring } from '@/support/String';
import { Lvs } from '@/models/Lvs';
import EditableTextarea from '@/components/EditableTextarea/EditableTextarea';
let Treatment = class Treatment extends Vue {
    constructor() {
        super(...arguments);
        this.activeTab = '/treatment';
        this.content = '';
        this.isSaving = false;
        this.areas = [];
        this.isLoadingLvs = true;
        this.treatmentLabels = [];
        this.selectedTreatments = [];
        this.treatmentLabelsLoaded = false;
        // protected onDebounceLvsDescription = debounce(this.onUpdateDescription, 1000)
        this.cachedLvsDescriptions = {};
        this.editorOptions = {
            modules: {
                magicUrl: true,
            },
        };
    }
    get dialogOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: ucstring(this.$t('dialogOptions.save', { item: this.$t('dialogOptions.item.treatment') }).toString()),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                },
            },
        };
    }
    get hasAreas() {
        return !!this.areas.length;
    }
    mounted() {
        this.fetchTreatmentLabels();
        this.fetchUserLvs();
        this.fetchStudent();
        this.switchQuillLanguage();
        this.$root.$on('locale-changed', this.switchQuillLanguage);
    }
    fetchStudent() {
        if (!this.student) {
            return;
        }
        new Student()
            .include(['treatment_labels', 'treatment'])
            .find(this.student.id)
            .then((student) => {
            this.student = student;
            this.setSelectedTreatments();
            this.setTreatment();
            this.treatmentLabelsLoaded = true;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    onEditorChange(quill, html) {
        this.content = html;
    }
    async save() {
        this.isSaving = true;
        try {
            const lvsDescriptions = Object.values(this.cachedLvsDescriptions);
            if (lvsDescriptions.length) {
                const promises = lvsDescriptions.map(({ event, area }) => this.updateLvsDescription(event, area));
                await Promise.all(promises);
            }
            const treatmentLabels = [];
            this.selectedTreatments.forEach((id) => {
                treatmentLabels.push({ id });
            });
            await this.student.updateTreatmentLabels(treatmentLabels)
                .catch((error) => {
                this.setSelectedTreatments();
                ErrorHandler.network(error);
            });
            const treatmentPayload = {
                user: this.student && this.student.id ? this.student.id : '',
                description: this.content,
            };
            await new TreatmentModel().updateTreatment(treatmentPayload)
                .catch((error) => {
                this.setTreatment();
                ErrorHandler.network(error);
            });
            this.$store.dispatch('openDialog', this.dialogOptions);
        }
        catch (error) {
            console.error('Error:', error);
        }
        finally {
            this.isSaving = false;
        }
    }
    setSelectedTreatments() {
        if (!this.student || !this.student.treatment_labels) {
            return;
        }
        this.selectedTreatments = this.student.treatment_labels.map((treatmentLabel) => {
            return treatmentLabel.id;
        });
    }
    setTreatment() {
        if (!this.student || !this.student.treatment) {
            return;
        }
        this.content = this.student.treatment.description || '';
    }
    closeDialog() {
        this.$emit('closed');
    }
    fetchTreatmentLabels() {
        this.treatmentLabelsLoaded = false;
        new TreatmentLabel()
            .all()
            .then((treatmentLabels) => {
            this.treatmentLabels = [...[], ...treatmentLabels];
            this.treatmentLabelsLoaded = true;
        });
    }
    async fetchUserLvs() {
        this.isLoadingLvs = true;
        new Lvs()
            .filter({ users: [this.student.id] })
            .all()
            .then((result) => {
            this.areas = result;
            this.isLoadingLvs = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isLoadingLvs = false;
        });
    }
    async updateLvsDescription(event, area) {
        if (!(this.$route.params && this.$route.params.id)) {
            return;
        }
        try {
            const response = await new Student({ id: this.$route.params.id })
                .setLvsAreasEndpoint()
                .create({
                subject_id: area.id,
                notes: event.value,
            });
            if (area.users) {
                area.users[this.student.id].notes = response.notes;
            }
        }
        catch (error) {
            event.setFailedState();
        }
    }
    switchQuillLanguage() {
        const editor = this.$refs.studentNotes;
        if (!editor) {
            return;
        }
        const placeholder = this.$t('quillEditor.placeholder').toString();
        editor.quill.root.dataset.placeholder = placeholder;
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Treatment.prototype, "student", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], Treatment.prototype, "dialog", void 0);
Treatment = __decorate([
    Component({
        components: {
            'quill-editor': quillEditor,
            'loader-card': LoaderCard,
            EditableTextarea,
        },
    })
], Treatment);
export default Treatment;
